/**
 * MsgIcon — inline SVG glyphs from the Claude Design "Client Messaging" spec
 * (MsgIc / MbIc). Scoped to the messaging screens; the appointment icon set
 * lives in src/components/ui/LavDropdown (Icon).
 */
const PATHS = {
	send: (
		<>
			<path d="M14 2L7.3 8.7" />
			<path d="M14 2L9.6 14 7.3 8.7 2 6.4 14 2z" />
		</>
	),
	bolt: <path d="M8.7 1.5L3.5 9h3.4l-.6 5.5L11.5 7H8.1l.6-5.5z" />,
	msg: (
		<path d="M14 7.6c0 2.9-2.7 5.2-6 5.2-.7 0-1.4-.1-2-.3L2.5 13.7l1-2.6C2.6 10.2 2 9 2 7.6 2 4.7 4.7 2.4 8 2.4s6 2.3 6 5.2z" />
	),
	auto: (
		<>
			<path d="M8 1.8l1.2 3.4 3.4 1.2-3.4 1.2L8 11l-1.2-3.4L3.4 6.4l3.4-1.2L8 1.8z" />
			<path d="M12.8 10.4l.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6.6-1.7z" />
		</>
	),
	checkc: (
		<>
			<circle cx="8" cy="8" r="6.2" />
			<path d="M5.4 8.3l1.8 1.8 3.4-3.7" />
		</>
	),
	bell: (
		<>
			<path d="M8 2a4 4 0 014 4c0 3 1.2 4 1.2 4H2.8S4 9 4 6a4 4 0 014-4z" />
			<path d="M6.7 13a1.4 1.4 0 002.6 0" />
		</>
	),
	back: <path d="M10.5 3L5.5 8l5 5" />,
	chev: <path d="M6 3.5L10.5 8 6 12.5" />,
	search: (
		<>
			<circle cx="7" cy="7" r="4.6" />
			<path d="M10.4 10.4 14 14" />
		</>
	),
	info: (
		<>
			<circle cx="8" cy="8" r="6.3" />
			<path d="M8 7.4v3.4" />
			<circle cx="8" cy="5.2" r="0.5" fill="currentColor" stroke="none" />
		</>
	),
}

function MsgIcon({ name, size = 16, sw = 1.8 }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			stroke="currentColor"
			strokeWidth={sw}
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			style={{ flex: 'none', display: 'block' }}
		>
			{PATHS[name] || null}
		</svg>
	)
}

/** Tiny "AI" pill used next to AI-powered actions. */
export function AiBadge() {
	return (
		<span
			style={{
				fontSize: '9.5px',
				fontWeight: 800,
				letterSpacing: '0.06em',
				color: '#5F4EC2',
				background: '#FFFFFF',
				border: '1px solid #D7CCF5',
				padding: '1px 6px',
				borderRadius: '99px',
				flex: 'none',
			}}
		>
			AI
		</span>
	)
}

export default MsgIcon
